import React from 'react'
import { Select, Space, Col, ConfigProvider } from 'antd';
import { Colors } from "../../config";
import useColors from '../../hooks/useColors';
import PaginatedSelect from '../PaginatedSelect';


const LabelWithSelect = ({ labelClass, inputClass, labeltext, labelColor, field, fieldState, options, mode, value, onChange, loading, placeholder = "", showSearch = false, allowClear = false,
    // pass either of these to get a searchable dropdown that loads while scrolling
    fetchPage, items, enabled = true, extraOptions, endMessage, showFullLabelToggle = false }) => {
    const { colorPrimary } = useColors()

    const isPaginated = typeof fetchPage === 'function' || Array.isArray(items);

    return (
        <div className="flex flex-col py-4 w-full">
            <label className={labelClass} style={{ color: labelColor ? labelColor : Colors.LabelColor }}>{labeltext}</label>
            <ConfigProvider
                theme={{
                    token: {
                        /* here is your global tokens */
                        // colorPrimary: Colors,
                    },
                    components: {
                        Select: {
                            /* here is your component tokens */
                            optionSelectedBg: colorPrimary,
                            optionActiveBg: Colors.LightGray,
                            optionSelectedColor: Colors.White,
                            selectorBg: Colors.LightGray,
                        },
                    },
                }}

            >
                {isPaginated ? (
                    <PaginatedSelect
                        mode={mode && 'multiple'}
                        {...field}
                        className={inputClass}
                        style={{ background: Colors.LightGray }}
                        fetchPage={fetchPage}
                        items={items}
                        enabled={enabled}
                        extraOptions={extraOptions}
                        endMessage={endMessage}
                        showFullLabelToggle={showFullLabelToggle}
                        placeholder={placeholder}
                        allowClear={allowClear}
                        loading={loading}
                        onChange={onChange || field?.onChange}
                    />
                ) : (
                    <Select
                        mode={mode && 'multiple'}
                        {...field}
                        className={inputClass}
                        style={{ background: Colors.LightGray }}
                        options={options}
                        showSearch={showSearch}
                        filterOption={showSearch ? (input, option) =>
                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            : null
                        }
                        allowClear={allowClear}
                        loading={loading}
                    />
                )}
            </ConfigProvider>
        </div>
    )
}

export default LabelWithSelect
